// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
:after,
:before {
    box-sizing: border-box;
}
h2 {
    margin-top: 0;
    margin-bottom: 0.5rem;
}
p {
    margin-top: 0;
    margin-bottom: 1rem;
}
img {
    border-style: none;
}
img {
    vertical-align: middle;
}
label {
    display: inline-block;
}
button {
    border-radius: 0;
}
button:focus {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color;
}
button,
input {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}
button,
input {
    overflow: visible;
}
button {
    text-transform: none;
}
button {
    -webkit-appearance: button;
    appearance: button;
}
button:not(:disabled) {
    cursor: pointer;
}
h2 {
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
}
h2 {
    font-size: 2rem;
}
.row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
}
.col-4 {
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
}
.col-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
}
.form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
    .form-control {
        transition: none;
    }
}
.form-control:focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.form-control::placeholder {
    color: #6c757d;
    opacity: 1;
}
.form-control:disabled {
    background-color: #e9ecef;
    opacity: 1;
}
.form-group {
    margin-bottom: 1rem;
}
.text-right {
    text-align: right !important;
}
.text-center {
    text-align: center !important;
}

@media print {
    *,
    :after,
    :before {
        text-shadow: none !important;
        box-shadow: none !important;
    }
    img {
        page-break-inside: avoid;
    }
    h2,
    p {
        orphans: 3;
        widows: 3;
    }
    h2 {
        page-break-after: avoid;
    }
}
* {
    box-sizing: border-box;
}
p {
    margin-bottom: 0;
}
.blue-btn:hover {
    color: #fff;
}
.text-d-blue {
    color: #050038;
}
.text-l-blue {
    color: #9babc5;
}
.text-error {
    color: #eb193f;
}
.text-blue {
    color: #004b8d;
}
.poppins {
    font-family: Poppins, sans-serif;
}

.metro-r {
    font-family: metropolisregular;
}

/* .login-wrapper {
  max-width: 392px;
} */

.blue-btn,
.metro-m {
    font-family: metropolismedium;
}
.cursor-pointer {
    cursor: pointer;
}
.text-right {
    text-align: right;
}
.text-center {
    text-align: center;
}
.pos-abs {
    position: absolute;
}
.pos-rel {
    position: relative;
}
.fw400 {
    font-weight: 400;
}
h2 {
    margin: 0;
    font-weight: 400;
}
.fs10 {
    font-size: 10px;
}
.fs11 {
    font-size: 11px;
}
.fs12 {
    font-size: 12px;
}
.fs14 {
    font-size: 14px;
}
.fs16 {
    font-size: 16px;
}
.fs20 {
    font-size: 20px;
}
.lh-12 {
    line-height: 12px;
}
.lh-14 {
    line-height: 14px;
}
.lh-16 {
    line-height: 16px;
}
.lh-20 {
    line-height: 20px;
}
@media (max-width: 767px) {
    .mr-t15 {
        margin-top: 15px;
    }
    .mr-t20 {
        margin-top: 20px;
    }
    .mr-b40 {
        margin-bottom: 40px;
    }
}
@media (min-width: 768px) {
    .margin-t5 {
        margin-top: 5px;
    }
    .margin-b5 {
        margin-bottom: 5px;
    }
    .margin-t15 {
        margin-top: 15px;
    }
    .margin-b20 {
        margin-bottom: 20px;
    }
    .margin-t35 {
        margin-top: 35px;
    }
    .margin-t40 {
        margin-top: 40px;
    }
    .margin-b60 {
        margin-bottom: 60px;
    }
    .margin-t65 {
        margin-top: 65px;
    }
}
.blue-btn {
    width: 100%;
    font-size: 16px;
    line-height: 16px;
    background: #004b8d;
    border-radius: 6px;
    border: none;
    padding: 15px;
    color: #fff;
}
input:-webkit-autofill {
    background-color: #fff !important;
}
input:-webkit-autofill,
input:-webkit-autofill:active,
input:-webkit-autofill:focus,
input:-webkit-autofill:hover {
    background-color: #fff !important;
    color: #555 !important;
    -webkit-box-shadow: inset 0 0 0 1000px #fff !important;
    -webkit-text-fill-color: #555 !important;
}

.info-card {
    width: 335px;
    background: #fff;
    padding: 25px 20px;
    border-radius: 24px;
    box-shadow: 10px 0 50px rgba(91, 68, 158, 0.1);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}
.user-card {
    width: 641px;
    height: 650px;
    background: #f8faff;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 24px;
    float: right;
    padding-left: 168px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.user-card .user-card-inner {
    padding: 20px 40px;
    width: 100%;
}
.user-card form input {
    border-radius: 0;
    border: none;
    border-bottom: 1px solid #9babc5;
    background: transparent;
    padding: 15px 1px;
    font-size: 16px;
    line-height: 16px;
    color: #050038;
    font-family: metropolismedium;
}
.user-card form input:focus {
    color: #050038;
    outline: none;
    box-shadow: none;
    background: none;
}
.user-card form input::placeholder {
    color: #9babc5;
    font-family: metropolisregular;
}
.user-card form .show-btn {
    right: 0;
    top: 12px;
}

/* .next,
.email-input {
  padding: 0.75rem 1rem;
  height: fit-content;
}
.email-input input {
  margin-left: 0.5rem;
}
.email-input:focus-within .ant-input-prefix svg path {
  stroke: var(--primary-blue-400);
} */
`, "",{"version":3,"sources":["webpack://./src/pages/login/login.css"],"names":[],"mappings":"AAAA;;;IAGI,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;;IAEI,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;;IAEI,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,WAAW;IACX,mCAAmC;IACnC,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;IACtB,wEAAwE;AAC5E;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI,cAAc;IACd,sBAAsB;IACtB,qBAAqB;IACrB,UAAU;IACV,gDAAgD;AACpD;AACA;IACI,cAAc;IACd,UAAU;AACd;AACA;IACI,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI;;;QAGI,4BAA4B;QAC5B,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;IACA;;QAEI,UAAU;QACV,SAAS;IACb;IACA;QACI,uBAAuB;IAC3B;AACJ;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;GAEG;;AAEH;;IAEI,6BAA6B;AACjC;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;AACf;AACA;IACI,iCAAiC;AACrC;AACA;;;;IAII,iCAAiC;IACjC,sBAAsB;IACtB,sDAAsD;IACtD,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,8CAA8C;IAC9C,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,6BAA6B;AACjC;AACA;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,8BAA8B;AAClC;AACA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;;;;;;;;;;GAUG","sourcesContent":["*,\n:after,\n:before {\n    box-sizing: border-box;\n}\nh2 {\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n}\np {\n    margin-top: 0;\n    margin-bottom: 1rem;\n}\nimg {\n    border-style: none;\n}\nimg {\n    vertical-align: middle;\n}\nlabel {\n    display: inline-block;\n}\nbutton {\n    border-radius: 0;\n}\nbutton:focus {\n    outline: 1px dotted;\n    outline: 5px auto -webkit-focus-ring-color;\n}\nbutton,\ninput {\n    margin: 0;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n}\nbutton,\ninput {\n    overflow: visible;\n}\nbutton {\n    text-transform: none;\n}\nbutton {\n    -webkit-appearance: button;\n    appearance: button;\n}\nbutton:not(:disabled) {\n    cursor: pointer;\n}\nh2 {\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n    line-height: 1.2;\n}\nh2 {\n    font-size: 2rem;\n}\n.row {\n    display: flex;\n    flex-wrap: wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n}\n.col-4 {\n    position: relative;\n    width: 100%;\n    padding-right: 15px;\n    padding-left: 15px;\n}\n.col-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n}\n.form-control {\n    display: block;\n    width: 100%;\n    height: calc(1.5em + 0.75rem + 2px);\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n    .form-control {\n        transition: none;\n    }\n}\n.form-control:focus {\n    color: #495057;\n    background-color: #fff;\n    border-color: #80bdff;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.form-control::placeholder {\n    color: #6c757d;\n    opacity: 1;\n}\n.form-control:disabled {\n    background-color: #e9ecef;\n    opacity: 1;\n}\n.form-group {\n    margin-bottom: 1rem;\n}\n.text-right {\n    text-align: right !important;\n}\n.text-center {\n    text-align: center !important;\n}\n\n@media print {\n    *,\n    :after,\n    :before {\n        text-shadow: none !important;\n        box-shadow: none !important;\n    }\n    img {\n        page-break-inside: avoid;\n    }\n    h2,\n    p {\n        orphans: 3;\n        widows: 3;\n    }\n    h2 {\n        page-break-after: avoid;\n    }\n}\n* {\n    box-sizing: border-box;\n}\np {\n    margin-bottom: 0;\n}\n.blue-btn:hover {\n    color: #fff;\n}\n.text-d-blue {\n    color: #050038;\n}\n.text-l-blue {\n    color: #9babc5;\n}\n.text-error {\n    color: #eb193f;\n}\n.text-blue {\n    color: #004b8d;\n}\n.poppins {\n    font-family: Poppins, sans-serif;\n}\n\n.metro-r {\n    font-family: metropolisregular;\n}\n\n/* .login-wrapper {\n  max-width: 392px;\n} */\n\n.blue-btn,\n.metro-m {\n    font-family: metropolismedium;\n}\n.cursor-pointer {\n    cursor: pointer;\n}\n.text-right {\n    text-align: right;\n}\n.text-center {\n    text-align: center;\n}\n.pos-abs {\n    position: absolute;\n}\n.pos-rel {\n    position: relative;\n}\n.fw400 {\n    font-weight: 400;\n}\nh2 {\n    margin: 0;\n    font-weight: 400;\n}\n.fs10 {\n    font-size: 10px;\n}\n.fs11 {\n    font-size: 11px;\n}\n.fs12 {\n    font-size: 12px;\n}\n.fs14 {\n    font-size: 14px;\n}\n.fs16 {\n    font-size: 16px;\n}\n.fs20 {\n    font-size: 20px;\n}\n.lh-12 {\n    line-height: 12px;\n}\n.lh-14 {\n    line-height: 14px;\n}\n.lh-16 {\n    line-height: 16px;\n}\n.lh-20 {\n    line-height: 20px;\n}\n@media (max-width: 767px) {\n    .mr-t15 {\n        margin-top: 15px;\n    }\n    .mr-t20 {\n        margin-top: 20px;\n    }\n    .mr-b40 {\n        margin-bottom: 40px;\n    }\n}\n@media (min-width: 768px) {\n    .margin-t5 {\n        margin-top: 5px;\n    }\n    .margin-b5 {\n        margin-bottom: 5px;\n    }\n    .margin-t15 {\n        margin-top: 15px;\n    }\n    .margin-b20 {\n        margin-bottom: 20px;\n    }\n    .margin-t35 {\n        margin-top: 35px;\n    }\n    .margin-t40 {\n        margin-top: 40px;\n    }\n    .margin-b60 {\n        margin-bottom: 60px;\n    }\n    .margin-t65 {\n        margin-top: 65px;\n    }\n}\n.blue-btn {\n    width: 100%;\n    font-size: 16px;\n    line-height: 16px;\n    background: #004b8d;\n    border-radius: 6px;\n    border: none;\n    padding: 15px;\n    color: #fff;\n}\ninput:-webkit-autofill {\n    background-color: #fff !important;\n}\ninput:-webkit-autofill,\ninput:-webkit-autofill:active,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:hover {\n    background-color: #fff !important;\n    color: #555 !important;\n    -webkit-box-shadow: inset 0 0 0 1000px #fff !important;\n    -webkit-text-fill-color: #555 !important;\n}\n\n.info-card {\n    width: 335px;\n    background: #fff;\n    padding: 25px 20px;\n    border-radius: 24px;\n    box-shadow: 10px 0 50px rgba(91, 68, 158, 0.1);\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n}\n.user-card {\n    width: 641px;\n    height: 650px;\n    background: #f8faff;\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n    border-radius: 24px;\n    float: right;\n    padding-left: 168px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.user-card .user-card-inner {\n    padding: 20px 40px;\n    width: 100%;\n}\n.user-card form input {\n    border-radius: 0;\n    border: none;\n    border-bottom: 1px solid #9babc5;\n    background: transparent;\n    padding: 15px 1px;\n    font-size: 16px;\n    line-height: 16px;\n    color: #050038;\n    font-family: metropolismedium;\n}\n.user-card form input:focus {\n    color: #050038;\n    outline: none;\n    box-shadow: none;\n    background: none;\n}\n.user-card form input::placeholder {\n    color: #9babc5;\n    font-family: metropolisregular;\n}\n.user-card form .show-btn {\n    right: 0;\n    top: 12px;\n}\n\n/* .next,\n.email-input {\n  padding: 0.75rem 1rem;\n  height: fit-content;\n}\n.email-input input {\n  margin-left: 0.5rem;\n}\n.email-input:focus-within .ant-input-prefix svg path {\n  stroke: var(--primary-blue-400);\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
